
import TableList from "@components/templates/tablelist";
// import { HttpProductList } from '@/service/inbound';
import { HttpGetErpsku } from '@/service/aftersales/aftersales';
export default {
    mixins: [TableList],
    data() {
        return {
            isMixin: true,
            Searchs: {
                show: true,
                style: "border:none;",
                labelWidth: 'auto',
                align: "left",
            },
        };
    },
    methods: {
        ajaxRequest: HttpGetErpsku,
        interceptRequest(params) {
            // params.search.EQ_status = 0
            params.search.EQ_enable = 1
            // delete params.rows
            // delete params.page
            return params
        },
    },
    computed: {
        SearchsData() {
            return [{
                label: "ERP SKU",
                tag: 'vInput',
                key: 'EQ_erpSku',
                show: true,
            },
            {
                label: this.$t('boss.purchase.name',{defaultValue:'名称'}),
                tag: 'vInput',
                key: 'EQ_name',
                show: true,
            }]
        },
        columns() {
            return [{
                title: "No.",
                type: 'index',
                width: 60,
            }, {
                title: "ERP SKU",
                key: 'erpSku'
            }, {
                title: this.$t('boss.purchase.name_chinese',{defaultValue:'名称(中文)'}),
                key: 'name'
            }, {
                title: this.$t('boss.purchase.name_english',{defaultValue:'名称(英文)'}),
                key: 'nameEn'
            },
            {
                title: this.$t('boss.purchase.operate',{defaultValue:'操作'}),
                width: 120,
                align: 'center',
                render: (h, { row }) => {
                    return h('vButton', {
                        props: {
                            theme: 'primary'
                        },
                        nativeOn: {
                            click: () => {
                                this.$emit('on-data', row)
                            }
                        }
                    }, this.$t('boss.purchase.select ',{defaultValue:'选择'}))
                }
            }]
        }
    }

};
